import Vue from 'vue'
import Keycloak from 'keycloak-js'

export default {
    init: function(callback) {
        let initoptions = {
            url: Vue.prototype.$config.keycloakconfig.baseurl,
            realm: Vue.prototype.$config.keycloakconfig.realm,
            clientId: Vue.prototype.$config.keycloakconfig.client,
            onLoad: undefined,
            checkLoginIframe: false
        }

        let keycloak = Keycloak(initoptions);

        keycloak.init({ checkLoginIframe: initoptions.checkLoginIframe }).then((/*auth*/) => {

            callback(keycloak)

            setInterval(() => {
                keycloak.updateToken(900)
                .catch((err) => {
                    // err is undefined if we're not logged in
                    // and on a page with no auth required
                    // BUT we still end up in the catch()
                    if (err) keycloak.logout()
                })
            }, 6000)
        }).catch(() => {
            console.log("Authentication Failed");
        });
    }
}